var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"home-layout",attrs:{"bgImage":true}},[_c('div',[_c('VListCardHomeLinks')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }